import React from 'react';
import {
  ConfigurationContext,
  ConfigurationContextValue,
  useConfiguration,
} from '@hooks/useConfiguration.tsx';

export const ConfigurationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { data: configuration, isLoading } = useConfiguration();

  const contextValue = { configuration, isLoading };

  return (
    <FixedConfigurationProvider value={contextValue}>
      {children}
    </FixedConfigurationProvider>
  );
};

export const FixedConfigurationProvider: React.FC<{
  children: React.ReactNode;
  value: ConfigurationContextValue;
}> = ({ children, value }) => {
  return (
    <ConfigurationContext.Provider value={value}>
      {children}
    </ConfigurationContext.Provider>
  );
};
